import React, { useEffect, useState } from 'react'
import '../CSS/main.css'
import Cockroach from '../imgs/Copilot_20260523_122622.png';
import Cockroach2 from '../imgs/Copilot_20260523_131251.png';
import Cocr from '../imgs/Gemini_Generated_Image_11mze311mze311mz.png'

  const handleJoinClick = (id) => {
    // Scroll to element with id="join"
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
const Header = () => {
  
    return (<header>
        <div className='header'>
            <h1 className='title width-full'>Cockroach Janata Party</h1>
            <div className='width-full set-items-to-right'>
                <div className='header-btns'>
                    <ul className='' style={{ listStyle: 'none', display: 'flex' }}>
                        <li className='member-btn gaps'><a style={{color:'white'}} href="#observation">Future Plan</a></li>
                        <li className='member-btn gaps'> <a style={{color:'white'}} href="#cjp">CJP ?</a></li>
                        <li className='member-btn gaps'><a style={{color:'white'}} href="#cjp">Make donation</a></li>
                        <li className='member-btn'><button onClick={()=>handleJoinClick('join')} className='btn-body'>Join CJP</button></li>
                    </ul>

                </div>
            </div>
        </div>
    </header>)
}
const BodyCockroach = ({width}) => {
    const [cocrochimg, setcockroach] = useState(Cockroach);

    useEffect(() => {
        const inter = setInterval(() => {
            setcockroach(cocrochimg === Cockroach ? Cockroach2 : Cockroach);
        }, 200);

        // Cleanup when component unmounts
        return () => clearInterval(inter);
    }, [cocrochimg]);

    return (<div>
        {Array.from({ length: (Math.round(width/30)-1) }).map((_, i) => (
            <img key={i} src={cocrochimg} width={30} height={30} />))}
    </div>)
}
const Member = ({ShareVis,SetShare}) => {
    const data = [{
        placeholder: "Enter your full name",
        type: "input",
        heading: 'Enter Full Name',
        dataType: 'text',
        max: 25,
        name: 'name',
        min: 10
    }, {
        placeholder: "Enter Your Email ID",
        type: "input",
        heading: 'Enter Email ID',
        dataType: 'email',
        max: 35,
        name: 'email',
        min: 10
    }, {
        placeholder: "Enter 10 digit Mobile Number",
        type: "input",
        heading: 'Enter Phone Number',
        dataType: 'number',
        max: 10,
        name: 'phone',
        min: 10
    }, {
        placeholder: "UPI Address",
        type: "input",
        heading: 'Enter your UPI Id',
        dataType: 'text',
        name: 'upi',
        max: 25,
        min: 6
    }]
    const [dataStore, StoreData] = useState({
        name: '',
        email: '',
        phone: '',
        upi: ''
    })
    const [inputBoxNo, SetNumberOfBox] = useState(0)
    return (<div id='join' className='member-container'>
       {!ShareVis&& <h4>Join CJP</h4>}
      {!ShareVis&&    data.map((v, i) => (<div className='data-container'><p className='title-memeber-details' style={{ marginLeft: inputBoxNo === i ? 2 : 0, fontFamily: 'monospace', color: inputBoxNo === i ? "orange" : "red" }}>{v.heading}*</p>
            <input required={true} name={v.name} value={dataStore[v.name]} onChange={(e) => StoreData({ ...dataStore, [e.target.name]: e.target.value })} type={v.dataType} max={v.max} min={v.min} className='input-memeber-details' placeholder={v.placeholder} onFocus={(e) => SetNumberOfBox(i)} /></div>
        ))}
        {!ShareVis&& <button style={btnSubmit.style} onClick={()=>SetShare(true)}> Submit</button>}

         {ShareVis&& <Share data={dataStore}/>}
        <br></br>
<CJPacoring />
    </div>
    )
}

const Share=({data})=>{
const [progress,setProgress]=useState(0)
const url =(language,p) =>{
    const value={en:`🪳 COCKROACH JANATA PARTY (CJP) BIG ANNOUNCEMENT 🪳

Brothers and sisters, your own ${data.name} is speaking. The chairman of CJP has happily decided today that every member will be given a maximum cash gift of ₹1,000,000!

If you also want to increase your bank balance, then without delay, immediately click on the link below and fill out your form:
👇👇👇
🔗  ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p}

Note: This scheme is on a first-come, first-served basis. Don't say later that you weren't informed! 🤫`,
ben:`🪳 ককরোচ জনতা পার্টি (CJP) এর বড় ঘোষণা 🪳

ভাই এবং বোনেরা, আপনার নিজের ${data.name} কথা বলছি। আজ সিজেপির চেয়ারম্যান আনন্দের সঙ্গে সিদ্ধান্ত নিয়েছেন যে প্রতিটি সদস্যকে সর্বাধিক ₹১,০০,০০০০ নগদ উপহার দেওয়া হবে!

যদি আপনি আপনার ব্যাঙ্ক ব্যালেন্স বাড়াতে চান, তবে দেরি না করে নীচের লিঙ্কে ক্লিক করে ফর্ম পূরণ করুন:
👇👇👇
🔗 ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p}

নোট: এই স্কিমটি প্রথম আসা, প্রথম পাওয়ার ভিত্তিতে। পরে বলবেন না জানাননি! 🤫`,
hi:`🪳 कॉकरोच जनता पार्टी (सीजेपी) का बड़ा ऐलान 🪳

भाइयों और बहनों, आपकी अपनी ${data.name} बोल रही है। CJP के अध्यक्ष ने आज खुशी-खुशी निर्णय लिया है कि हर सदस्य को अधिकतम ₹1,000,000 नकद उपहार दिया जाएगा!

अगर आप भी अपना बैंक बैलेंस बढ़ाना चाहते हैं तो बिना देर किए तुरंत नीचे दिए गए लिंक पर क्लिक करें और अपना फॉर्म भरें:
👇👇👇
🔗 ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p}

नोट: यह योजना पहले आओ, पहले पाओ के आधार पर है। बाद में यह न कहें कि आपको सूचित नहीं किया गया था! 🤫`
}

    const valueforLink={en:`2.2COCKROACH JANATA PARTY (CJP) BIG ANNOUNCEMENT2.2 2.3 2.3
Brothers and sisters, your own ${data.name} is speaking. The chairman of CJP has happily decided today that every member will be given a maximum cash gift of ₹1,000,000!2.3 2.3
If you also want to increase your bank balance, then without delay, immediately click on the link below and fill out your form:2.3
2.3
  ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p}2.3 2.3
> Note: This scheme is on a first-come, first-served basis. Don't say later that you weren't informed! `,
ben:`2.2ককরোচ জনতা পার্টি (CJP) এর বড় ঘোষণা2.2 2.3 2.3
ভাই এবং বোনেরা, আপনার নিজের ${data.name} কথা বলছি। আজ সিজেপির চেয়ারম্যান আনন্দের সঙ্গে সিদ্ধান্ত নিয়েছেন যে প্রতিটি সদস্যকে সর্বাধিক ₹১,০০,০০০০ নগদ উপহার দেওয়া হবে!2.3 2.3
যদি আপনি আপনার ব্যাঙ্ক ব্যালেন্স বাড়াতে চান, তবে দেরি না করে নীচের লিঙ্কে ক্লিক করে ফর্ম পূরণ করুন:  2.3 2.3
  ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p} 2.3 2.3
> নোট: এই স্কিমটি প্রথম আসা, প্রথম পাওয়ার ভিত্তিতে। পরে বলবেন না জানাননি! `,
hi:`2.2कॉकरोच जनता पार्टी (सीजेपी) का बड़ा ऐलान2.2 2.3 2.3
भाइयों और बहनों, आपकी अपनी ${data.name} बोल रही है। CJP के अध्यक्ष ने आज खुशी-खुशी निर्णय लिया है कि हर सदस्य को अधिकतम ₹1,000,000 नकद उपहार दिया जाएगा!2.3 2.3
अगर आप भी अपना बैंक बैलेंस बढ़ाना चाहते हैं तो बिना देर किए तुरंत नीचे दिए गए लिंक पर क्लिक करें और अपना फॉर्म भरें:2.3
👇👇👇2.3
  ${window.location.href}?user=${(data.name).toString().replaceAll(" ","split")}-key-${Math.random(100000).toString().replace('.','')}-process-${p}2.3 2.3
> नोट: यह योजना पहले आओ, पहले पाओ के आधार पर है। बाद में यह न कहें कि आपको सूचित नहीं किया गया था! `
}
    const returnValue=language==="hi"?value.hi:language==="en"?value.en:value.ben
    const returnValueLink=language==="hi"?valueforLink.hi:language==="en"?valueforLink.en:valueforLink.ben;
    const replace1=returnValueLink.replaceAll("2.2","*");
    const forPressUrl=replace1.replaceAll('2.3',"%0A")
    return {forshow:returnValue,forClick:forPressUrl}}
const handleSend = (x,p) => {
window.open("https://wa.me/?text="+url(x,p).forClick, "_blank");
setProgress(progress+1);
};
const [lang,setLang]=useState('en');
const languageItems=[{language:"Bengali",
    sign:"ben"
},
{language:"Hindi",
    sign:"hi"
},{language:"English",
    sign:"en"
}]
return (<div>
    <div className='progress-bar' style={{backgroundImage:`linear-gradient(90deg, #020b1e ${progress<10? progress*10:100-2}%, white ${progress<10? progress*10+2:100}%, #3a3a3b 0%)`,color:'white'}}>Wining Possibility {progress===0?"1%":(10*progress-1)>99?"99%":(10*progress-1)+"%"}</div>
    <div>{languageItems.map((v,i)=>(<button onClick={()=>setLang(v.sign)} className={v.sign===lang?'language-btn-selected':'language-btn-not-selected'}>{v.language}</button>))} </div>
   <textarea style={{height:280,width:400}} value={url(lang,progress+1).forshow}/>
   <div style={{display:'inline-flex',flexDirection:'inherit'}}>{Array.from({length:10}).map((_,i)=>(
    <div style={i<progress?btnSubmit.doneProgSty:i===progress?btnSubmit.curProgSty:btnSubmit.inProgSty} className='progress-dot'>{i<progress?'✓':i===progress?'▩':'⊘'}</div>
   ))}</div>
    <button className='btn-body' style={{width:400}}  onClick={()=>handleSend(lang,progress+1)}>Share with your friends</button>
    
    </div>);
}
const CJPacoring = () => {
  
    return (<div style={btnSubmit.theame}><img src={Cocr} style={{ borderRadius: 25 }} width={450} height={400} /></div>)
}
const  getWindowSize=()=> {
const { innerWidth, innerHeight } = window;
return { innerWidth, innerHeight };
}
const Home = () => {
    const [windowSize, setWindowSize] = useState(getWindowSize());
const [ShowShareContainer,SetVisibleShareContainer]=useState(false);
useEffect(() => {
function handleWindowResize() {
setWindowSize(getWindowSize());
}

window.addEventListener('resize', handleWindowResize);

return () => {
window.removeEventListener('resize', handleWindowResize);
};
}, []);

    return (
        <div>
            <Header />
            <BodyCockroach width={windowSize.innerWidth}/>
            <div style={{display:'flex',flexFlow:'wrap',justifyContent:'center'}}>
                <div> <div className='top-border'><p className='top'>
                   The Cockroach Janata Party, with its 10M follower milestone, presents a new way of thinking. We are not a political party, nor do we stand against any party. Our sole aim is that whenever there are shortcomings or wrong decisions in the system, they are highlighted in a constructive manner.
                    </p></div></div>
                    
                     <div> <div className='top-border'><p className='top'>
                   Our voice is a new perspective — which is not just for criticism, but for improvement. We want every citizen and every party to come together to create a perfect system, where decisions are in the interest of the people and governance is even more transparent and accountable.   </p></div></div>
                    

                     <div> <div className='top-border'><p className='top'>
                 For the Cockroach Janata Party, 10M followers mean a collective voice that is beyond just politics. It is a platform where every individual can express their thoughts, and any party can join us if their goal is to strengthen the system.    </p></div></div>
                    </div>
            <div style={{ display:windowSize.innerWidth>680?'inline-flex':'ruby' }}>
                <Member ShareVis={ShowShareContainer} SetShare={SetVisibleShareContainer}/>
                
                <Faqs />
            </div>
            <div id='observation' className='observation'>Cockroach Janata Party is not a political party, but a people-driven observation platform with over 10 million followers. Its purpose is to highlight flaws in governance and decision-making without opposing any specific party. The initiative focuses on constructive criticism, transparency, and accountability, aiming to strengthen the system rather than divide it. It welcomes participation from individuals and parties alike, encouraging collective effort to build a fair, efficient, and perfect system for everyone.</div>
        </div>
    )
}

const Faqs = () => {
      const quest = [{
        Q: "Why Cockroach?",
        Ans: "Habit of 'surviving': The characteristic of cockroaches is that they survive even in all kinds of bad conditions. Therefore, leaders who frequently change their party (party-switchers) or manage to save a ministerial position in every government, people jokingly call them or their party 'Cockroach' to satirize them."
    },
    {
        Q: "Why Janata Party !",
        Ans:"Inspired from Bharatiya Janata Party."
    },
    {
        Q:'Our Focus !',
        Ans:'Social Media Content: Many content creators on YouTube, Instagram Reels, or Facebook create such fictional parties and make funny election rallies, speeches, and manifesto parodies to make people laugh.'
    },
    {
        Q:'Why Giving ₹500',
        Ans:"Recently we reached 10M users, so we are providing a giveaway of ₹500 (USD 5) up to ₹1000000 (USD 10000)"
    },
    {
        Q:'Increase win possibility !',
        Ans:"Share and the message via whatsapp and increase the winning possibility!"
    }
]
    return (<div id='cjp' className='faq-body'>{
        quest.map((v,i)=>(
        <div key={i} className='faq-container'>
            <div className='faq-title'>{v.Q}</div>
            <div className='faq-ans'>{v.Ans}</div>
          
        </div>))}
    </div>)
}
const btnSubmit = {
    style: {
        border: '1px solid green',
        fontSize: 20,
        fontFamily: 'cursive',
        marginTop: 10,
        borderRadius: 20,
        background: '#751919',
        color: 'beige'
    },
    theame: {
        width: 450,
        height: 400,
        marginLeft: 2,
        border: "2px solid green",
        borderRadius: 25
    },
    inProgSty:{
        background:`linear-gradient(130deg, rgb(59, 35, 2) 0%, rgb(111 80 80) 50%, #7f3a07 0%)`
    },
    doneProgSty:{
        background:`linear-gradient(220deg, rgb(38 71 0) 50%, #8BC34A 50%, rgb(0 63 3) 20%);`
    },
    curProgSty:{
        background:`linear-gradient(40deg, rgb(0 0 0) 40%, rgb(91 82 82) 60%, rgb(127, 58, 7) 40%)`
    }
}
export default Home

